import React from "react";

/* eslint-disable react/display-name */
export default React.memo(() => {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.8002 10.9999C21.8002 16.9646 16.9648 21.7999 11.0002 21.7999C5.03558 21.7999 0.200195 16.9646 0.200195 10.9999C0.200195 5.03527 5.03558 0.199951 11.0002 0.199951C16.9648 0.199951 21.8002 5.03527 21.8002 10.9999ZM13.5562 16.4124L9.2037 13.1968L14.2119 8.6775C14.4316 8.48238 14.1637 8.38733 13.8719 8.56427L7.69146 12.4635L5.02169 11.6302C4.44531 11.4537 4.44109 11.0575 5.15124 10.7727L15.5543 6.76131C16.0295 6.54558 16.4881 6.87552 16.3067 7.60271L14.535 15.9514C14.4112 16.5446 14.053 16.6865 13.5562 16.4124Z"
                fill="white"
            />
        </svg>
    );
});